import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  registerData: {}
}

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setRegisterData: (state, action) => {
      state.registerData = action.payload
    }
  }
})

export const { setRegisterData } = formSlice.actions
export default formSlice.reducer
